import { useEffect, useState } from "react";
import { Button, Group, Stack, Text, Textarea, Title } from "@mantine/core";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { getCurrentUser } from "aws-amplify/auth";
import { GraphQLQuery, generateClient } from "aws-amplify/api";
import { useUserProvider } from "@/utils/UserProvider";
import { appShowNotification } from "@/utils/utils";
import { updateUser } from "@/graphql/mutations";
import { UpdateUserInput, UpdateUserMutation } from "@/API";

const client = generateClient();

interface UserDefaultNormalProps {}

const UserDefaultNormal: React.FC<UserDefaultNormalProps> = () => {
  const userSelector = (context: any) => [context.user];
  const { user } = useAuthenticator(userSelector);
  const [normalText, setNormalText] = useState("");
  const [loading, setLoading] = useState(false);
  const { amplifyUser } = useUserProvider();

  useEffect(() => {
    setNormalText(amplifyUser.defaultNormalText);
  }, [amplifyUser]);

  const handleEditProfile = async () => {
    setLoading(true);
    try {
      const updatedUser: UpdateUserInput = {
        id: user.username,
        defaultNormalText: normalText,
        _version: amplifyUser._version,
      };
      await client.graphql<GraphQLQuery<UpdateUserMutation>>({
        query: updateUser,
        variables: { input: updatedUser },
      });
      await getCurrentUser();
      appShowNotification({
        message: "Default normal text updated successfully",
        title: "Success",
        variant: "success",
        type: "success",
      });
    } catch (err) {
      console.error("error editing profile:", err);
      appShowNotification({
        message: "Error editing default normal text, please try again",
        title: "Error",
        variant: "danger",
        type: "error",
      });
    }
    setLoading(false);
  };

  return (
    <Stack gap={0} p="md">
      <Title order={3}>Default normal text</Title>
      <Text size="sm" c="dimmed" mt="md">
        Set your preferred language for the parts of your template that aren't
        mentioned. You do not need to mention normals in your cases, Manta Classic
        will automatically populate your template with your default normals!
      </Text>
      <Textarea
        placeholder="Enter default normal text"
        value={normalText}
        onChange={(event) => setNormalText(event.currentTarget.value)}
        minRows={4}
        mt="md"
        autosize
      />
      <Group mt="lg">
        <Button
          loading={loading}
          disabled={loading}
          w="200px"
          h="50px"
          fw={500}
          radius={30}
          onClick={handleEditProfile}
        >
          Save
        </Button>
      </Group>
    </Stack>
  );
};

export default UserDefaultNormal;
